"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "knockAnswered", {
  enumerable: true,
  get: function get() {
    return _knockAnswered["default"];
  }
});
var _knockAnswered = _interopRequireDefault(require("./knockAnswered"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }